import { commonEnvironment } from './common.environment';

export const environment = {
  ...commonEnvironment,
  production: true,
  envName: 'prod',
  authServerUrl: 'https://auth.cloud.triarc-labs.com/auth',
  serverApiUrl: 'https://aion-api.cloud.triarc-labs.com',
  sentry: {
    dsn: 'https://5723bba992b015970906fa414f6992fd@o296516.ingest.us.sentry.io/4508810980884480',
  },
};
